// The catalog of available Well-Architected Reviews (WARs). Each entry is a
// framework content artifact, validated through frameworkSchema at import.
// Add a new WAR by importing its content JSON and appending it to `frameworks`.

import type { FrameworkDefinition } from '../types/framework';
import type { WarSummary } from '../types/dto';
import databricksRaw from './framework.v1.json';
import aiMaturityStrategicRaw from './ai-maturity-strategic.json';
import aiMaturityTacticalRaw from './ai-maturity-tactical.json';
import { frameworkSchema } from './schema';

const parse = (raw: unknown): FrameworkDefinition => frameworkSchema.parse(raw);

/** All available WARs, in display/chooser order. */
export const frameworks: FrameworkDefinition[] = [
  parse(databricksRaw),
  parse(aiMaturityStrategicRaw),
  parse(aiMaturityTacticalRaw),
];

/** The WAR shown when none is specified (and the redirect target of a bare `/`). */
export const DEFAULT_FOCUS = 'databricks';

export function getFrameworkByFocus(focus: string): FrameworkDefinition | undefined {
  return frameworks.find((f) => f.focus === focus);
}

/** Catalog entries for the chooser (no pillar/question payload). */
export function listWars(): WarSummary[] {
  return frameworks.map((f) => ({ focus: f.focus, title: f.title, tagline: f.tagline }));
}
